module.exports = __webpack_public_path__ + "assets/img/22_282.6b8fb673.jpg";